/*
 * @Author: hai.zhang
 * @LastEditors: Gexiaolei gxiaolei@163.com
 * @Date: 2019-08-19 10:12:38
 * @LastEditTime: 2023-01-12 15:44:07
 */
export default {
  fixed: [
    {
      name: 'easy-edit-loading',
      path: '/pr/easy-edit-loading',
      component: () => import(/* webpackChunkName: "purchase-center-edit" */'../routes/pr-paas/create/pr-submit-loading/index.vue'),
      meta: {
        title: {
          'zh-CN': '采购申请提交中',
          en: '采购申请提交中_en',
          jp: '采购申请提交中_jp'
        },
        spmB: 'b396',
        isNewHeader: true,
        menuCode: '/pr/center',
        noTopPadding: true,
        i18nCode: 'pr-paas/create/easy-edit-loading'
      }
    },
    {
      name: 'easy-edit',
      path: '/pr/easy-edit',
      component: () => import(/* webpackChunkName: "purchase-center-edit" */'../routes/pr-paas/create/edit/index.vue'),
      meta: {
        title: {
          'zh-CN': '编辑采购申请单',
          en: '编辑采购申请单_en',
          jp: '编辑采购申请单_jp'
        },
        spmB: 'b396',
        isNewHeader: true,
        menuCode: '/pr/center',
        i18nCode: 'pr-paas/create/edit'
      }
    },
    // 采购中心-编辑导入采购申请单
    {
      name: 'pr-manually-create-edit',
      path: '/pr/manually-create-edit',
      component: () => import(/* webpackChunkName: "purchase-manually-create-edit" */'../routes/pr-paas/manually-create/edit/index.vue'),
      meta: {
        title: '编辑采购申请单',
        spmB: 'b11',
        noTranslation: true,
        isNewHeader: true,
        menuCode: '/pr/center'
      }
    },
    // 采购中心-查看采购申请单 apaas实现
    {
      name: 'pr-info',
      path: '/pr/info',
      component: () => import(/* webpackChunkName: "purchase-center-info" */'../routes/pr-paas/create/info/index.vue'),
      meta: {
        title: {
          'zh-CN': '查看采购申请单',
          en: '查看采购申请单_en',
          jp: '查看采购申请单_jp'
        },
        spmB: 'b12',
        isNewHeader: true,
        menuCode: '/pr/center',
        i18nCode: 'pr-paas/create/info'
      }
    },
    {
      name: 'pr-manually-create-info',
      path: '/pr/manually-create-info',
      component: () => import(/* webpackChunkName: "purchase-center-info" */'../routes/pr-paas/manually-create/info/info.vue'),
      meta: {
        title: '查看采购申请单',
        spmB: 'b12',
        noTranslation: true,
        isNewHeader: true,
        menuCode: '/pr/center'
      }
    },
    // 采购中心-批量导入采购商品（最新版本）
    {
      name: 'pr-new-import',
      path: '/pr/new-import',
      component: () => import(/* webpackChunkName: "pr-newimport" */'../routes/pr-paas/new-import-create/edit/index.vue'),
      meta: {
        title: '批量导入采购商品',
        spmB: 'b481',
        isNewHeader: true,
        menuCode: '/pr/center',
        i18nCode: 'pr-paas/new-import-create/edit'
      }
    },
    // 采购中心-查看批导-批导详情（最新版本）
    {
      name: 'pr-new-import-info',
      path: '/pr/new-import-info',
      component: () => import(/* webpackChunkName: "pr-new-import-info" */'../routes/pr-paas/new-import-create/info/index.vue'),
      meta: {
        title: {
          'zh-CN': '查看导入采购申请单',
          en: '查看导入采购申请单_en',
          jp: '查看导入采购申请单_jp'
        },
        spmB: 'b482',
        i18nCode: 'pr-paas/new-import-create/info',
        isNewHeader: true,
        menuCode: '/pr/center'
      }
    }
  ],
  field: [
    // 采购中心-采购申请单
    {
      name: 'pr-center',
      path: '/pr/center',
      component: () => import(/* webpackChunkName: "purchase-center" */'../routes/pr-paas/center/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的采购申请单',
          en: '我的采购申请单_en',
          jp: '我的采购申请单_jp'
        },
        spmB: 'b15',
        isNewHeader: true,
        i18nCode: 'pr-paas/pr-center'
      }
    }
  ]
}
